//#region import
import React, { Fragment, createContext, useContext, useEffect, useRef, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, DefaultArrayEmpty, Extension, FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs, OptionsProjectStatus_1, OptionsProjectStatus_2, OptionsProjectStatus_3 } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnDownload, BtnDraft, BtnEdit, BtnExample, BtnSave, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import { FormProvider, useForm } from 'react-hook-form';
import { TextBoxItem } from 'components/Input/TextBox';
import AccordionPanel from '../components/AccordionPanel';
import { RadioListItem } from 'components/Input/Radio';
import { SelectItem } from 'components/Input/Select/SelectItem';
import HeaderInput from 'components/Input/HeaderInput';
import {SettingsSuggest, Description} from '@mui/icons-material';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import UploadFileItem, { downloadFile } from 'components/Input/UploadFile';
import { TextAreaItem } from 'components/Input/TextArea';
import moment from 'moment';
import { useLocation } from 'react-router';
import NumberInput from 'view/Backend/IncomeExpenses/Ticket/components/NumberInput';
import NumberInputCustom from '../components/NumberInputCustom';
import InputNumberItem from 'components/Input/InputNumber';
//#endregion

const Panel0 = () => {
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel9,
        setisChangePanel9,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        nProjectVersionID,
        nProgressStatusID,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);

    //#region useState
    const [isComplete, setisComplete] = useState(null);
    const [ObjExampleFile_1, setObjExampleFile_1] = useState(null);
    const [ObjExampleFile_2, setObjExampleFile_2] = useState(null);
    const [ObjExampleFile_3, setObjExampleFile_3] = useState(null);

    const [arrDataSectionTypeID, setarrDataSectionTypeID] = useState([]);
    const [arrDataOperationType, setarrDataOperationType] = useState([]);
    const [arrDataUnitType, setarrDataUnitType] = useState([]);
    const [arrDataFileType, setarrDataFileType] = useState([]);

    const [arrDataProvince, setarrDataProvince] = useState([]);
    const [arrDataDistrict, setarrDataDistrict] = useState([]);
    const [arrDataSubDistrict, setarrDataSubDistrict] = useState([]);    

    const onClearFile_1 = useRef(null);
    const [arrFile_1, setarrFile_1] = useState([]);        
    const onClearFile_2 = useRef(null);
    const [arrFile_2, setarrFile_2] = useState([]);        
    const onClearFile_3 = useRef(null);
    const [arrFile_3, setarrFile_3] = useState([]);        
    const onClearFile_4 = useRef(null);
    const [arrFile_4, setarrFile_4] = useState([]);        
    const onClearFile_5 = useRef(null);
    const [arrFile_5, setarrFile_5] = useState([]);        
    const onClearFile_6 = useRef(null);
    const [arrFile_6, setarrFile_6] = useState([]);        
    const onClearFile_7 = useRef(null);
    const [arrFile_7, setarrFile_7] = useState([]);        
    const onClearFile_8 = useRef(null);
    const [arrFile_8, setarrFile_8] = useState([]);        
    const onClearFile_9 = useRef(null);
    const [arrFile_9, setarrFile_9] = useState([]);

    const [isFile_5_isDocumentTor, setisFile_5_isDocumentTor] = useState(true);
    const [isFile_6_isPriceReference, setisFile_6_isPriceReference] = useState(true);
    const [isFile_9_isPowerOfAttorney, setisFile_9_isPowerOfAttorney] = useState(true);
    const [isFile_10_isIntegrationUnit, setisFile_10_isIntegrationUnit] = useState(true);        
    const [isFundOwnership_sFundOwnership, setisFundOwnership_sFundOwnership] = useState(true);
    //#endregion

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sProjectName: null,
            nSectionID: null,
            nOperationTypeID: null,
            sOperationOther: null,
            nUnitTypeID: null,
            sUnitOwnerName: null,
        } as any,
    });

    const formDocument = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            isFundOwnership: "Y",
            sFundOwnership: null,
            isDocumentTor: "Y",
            isPriceReference: "Y",
            isPowerOfAttorney: "Y",
            isIntegrationUnit: "Y",
        } as any,
    });

    useEffect(() => {
        GetFormInitial();      
        onGetProvince();
    }, []);

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        GetFormInitial();
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID, isFastTrack]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectPanel0, { nProjectID : nProjectID, isFastTrack: isFastTrack, }, (result) => { 
            setObjExampleFile_1(result.ObjExampleFile_1);
            setObjExampleFile_2(result.ObjExampleFile_2);
            setObjExampleFile_3(result.ObjExampleFile_3);
            setarrDataSectionTypeID(result.lstSectionTypeID);
            setarrDataOperationType(result.lstOperationTypeID);
            setarrDataUnitType(result.lstUnitTypeID);
            if(nProjectID === 0 && result.nUnitTypeID_Default !== null) form.setValue("nUnitTypeID", result.nUnitTypeID_Default); 
            setarrDataFileType(result.lstFileTypeID);
            // handleGetTableProject(dataRow);
        });
    }

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel0, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);

            form.setValue("sProjectName", result.objResult.sProjectName);
            form.setValue("nSectionID", result.objResult.nSectionID);
            form.setValue("nOperationTypeID", result.objResult.nOperationTypeID);
            form.setValue("sOperationOther", result.objResult.sOperationOther);
            form.setValue("nUnitTypeID", result.objResult.nUnitTypeID);
            form.setValue("sUnitOwnerName", result.objResult.sUnitOwnerName);
            setarrProjectExecutive(result.objResult.lstProjectExecutive);              
            setDataRowExecutive({
                ...initRows,
                nDataLength: result.objResult.lstProjectExecutive.length,
                arrRows: result.objResult.lstProjectExecutive,
            });
            formDocument.setValue("isFundOwnership", result.objResult.isFundOwnership === true ? "Y" : "N");
            setisFundOwnership_sFundOwnership(result.objResult.isFundOwnership);
            formDocument.setValue("sFundOwnership", result.objResult.sFundOwnership);
            formDocument.setValue("isDocumentTor", result.objResult.isDocumentTor === true ? "Y" : "N");
            setisFile_5_isDocumentTor(result.objResult.isDocumentTor);
            formDocument.setValue("isPriceReference", result.objResult.isPriceReference === true ? "Y" : "N");
            setisFile_6_isPriceReference(result.objResult.isPriceReference);
            formDocument.setValue("isPowerOfAttorney", result.objResult.isPowerOfAttorney === true ? "Y" : "N");
            setisFile_9_isPowerOfAttorney(result.objResult.isPowerOfAttorney);

            setarrFile_1(result.objResult.lstFileDocument_1);
            setarrFile_2(result.objResult.lstFileDocument_2);
            setarrFile_3(result.objResult.lstFileDocument_3);
            setarrFile_4(result.objResult.lstFileDocument_4);
            setarrFile_5(result.objResult.lstFileDocument_5);
            setarrFile_6(result.objResult.lstFileDocument_6);
            setarrFile_7(result.objResult.lstFileDocument_7);
            setarrFile_8(result.objResult.lstFileDocument_8); 
            setarrFile_9(result.objResult.lstFileDocument_9); 
            
            formDocument.setValue("isIntegrationUnit", result.objResult.isIntegrationUnit === true ? "Y" : "N");
            setisFile_10_isIntegrationUnit(result.objResult.isIntegrationUnit);
            setarrProjectSecondaryUnit(result.objResult.lstProjectSecondaryUnit);  

            setDataRowSecondaryUnit({
                ...initRows,
                nDataLength: result.objResult.lstProjectSecondaryUnit.length,
                arrRows: result.objResult.lstProjectSecondaryUnit,
            });
        });
    };

    //#region Executive
    const [nExecutiveIDEdit, setnExecutiveIDEdit] = useState(0);
    const [ObjExecutiveIDEdit, setObjExecutiveIDEdit] = useState(null);
    const [arrProjectExecutive, setarrProjectExecutive] = useState([]);
    const [DataRowExecutive, setDataRowExecutive] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formExecutive = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sTitle: null,
            sFName: null,
            sLName: null,
            sPosition: null,
            sPositionAddress: null,
            nProvinceID: null,
            nDistrictID: null,
            nSubDistrictID: null,
            sTelNo: null,
            sEmail: null,
            sLineID: null
        } as any,
    });
    
    const onGetProvince = () => {
        formExecutive.setValue("nSubDistrictID", null);
        formExecutive.setValue("nDistrictID", null);
        DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetProvinceData, {}, (result) => {
            if (result.nStatusCode === APIStatusCode.Success) {
                setarrDataProvince(result.Data.lstTMProvince);
            }
            DialogFn.UnBlockUI();
        },(err) => {
            DialogFn.UnBlockUI();
        });
    };

    const onGetDistrict = (nProvinceID) => {
        formExecutive.setValue("nSubDistrictID", null);
        if (nProvinceID) {
            DialogFn.BlockUI();
            AxiosFn.Get(ApiProject.GetDistrictData, { nProvinceID: parseInt(nProvinceID) } , (result) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    setarrDataDistrict(result.Data.lstTMDistrict);
                }
                DialogFn.UnBlockUI();
            },(err) => {
                DialogFn.UnBlockUI();
            });
        } else {
            setarrDataDistrict([]);
        }
    };

    const onGetSubDistrict = (nDistrictID) => {
        if (nDistrictID) {
            DialogFn.BlockUI();
            AxiosFn.Get(ApiProject.GetSubDistrictData, { nDistrictID: parseInt(nDistrictID) } , (result) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    setarrDataSubDistrict(result.Data.lstTMSubDistrict);
                }
                DialogFn.UnBlockUI();
            },(err) => {
                DialogFn.UnBlockUI();
            });           
        } else {
            setarrDataSubDistrict([]);
        }
    };   

    const dataColumnExecutive : any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) && nStatusID !== EnumProjectStatusID.nStatusID_11 ?
                        <>                            
                            <BtnDeleteOnTable
                                key={"btnDelete_Executive_" + item.row.sID}
                                id={"btnDelete_Executive_" + item.row.sID}
                                onClick={() => onDeleteExecutive(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />           
                            <BtnEditOnTable
                                key={"btnEdit_Executive_" + item.row.sID}
                                id={"btnEdit_Executive_" + item.row.sID}
                                onClick={() => onEditExecutive(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Executive_" + item.row.sID}
                            id={"btnView_Executive_" + item.row.sID}
                            onClick={() => onEditExecutive(item.row, EnumStatusMode.View)}
                            // IsDisabled={isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nNo",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sUserName",
            headerName: "ชื่อ-นามสกุล",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 4,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sPosition",
            headerName: "ตำแหน่ง",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
    ];

    const onAddExecutive = () => {
        let ObjForm = formExecutive.getValues();
        let ObjDuplicate = arrProjectExecutive.filter((f) => !f.isDelete && (nExecutiveIDEdit !== 0 ? f.nID !== nExecutiveIDEdit : true) && f.sTitle === ObjForm.sTitle && f.sFName === ObjForm.sFName && f.sLName === ObjForm.sLName);
        if ((ObjDuplicate || []).length === 0)
        {      
            //#region Old
            // let nExecutiveID = 0;
            // let dataRow = DataRowExecutive;
            // let arrExecutive = DefaultArrayEmpty(arrProjectExecutive);
            // let nMaxID = new LINQ<any>(arrExecutive).Any() ? new LINQ<any>(arrExecutive).Max((m) => m.nID) + 1 : 1;
            // if (nExecutiveIDEdit) {
            //     arrExecutive = arrExecutive.filter((f) => f.nID !== nExecutiveIDEdit);
            //     nExecutiveID = arrProjectExecutive.find((f) => f.nID === nExecutiveIDEdit)?.nExecutiveID;
            //     nMaxID = nExecutiveIDEdit;
            // }
            // let obj = {
            //     isDelete: false,
            //     isEdit: false, 
            //     sID: nMaxID.toString(),
            //     nNo: nMaxID,
            //     nID: nMaxID,
            //     nExecutiveID: nExecutiveID,
            //     sTitle: ObjForm.sTitle,
            //     sFName: ObjForm.sFName,
            //     sLName: ObjForm.sLName,
            //     sUserName: ObjForm.sTitle + " " + ObjForm.sFName + " " + ObjForm.sLName,
            //     sPosition: ObjForm.sPosition,
            //     sPositionAddress: ObjForm.sPositionAddress,
            //     nProvinceID: Convert.StringToInt(ObjForm.nProvinceID),
            //     nDistrictID: Convert.StringToInt(ObjForm.nDistrictID),
            //     nSubDistrictID: Convert.StringToInt(ObjForm.nSubDistrictID),
            //     sTelNo: ObjForm.sTelNo,
            //     sEmail: ObjForm.sEmail,
            //     sLineID: ObjForm.sLineID
            // };

            // let nNo = 1;
            // let result = [...arrExecutive, obj];
            // // result.forEach(f => f.nNo = nNo++);
            // result.forEach(f => {
            //     if (f.isDelete === true) {
            //         f.nNo = 0;
            //     } else {
            //         f.nNo = nNo++;
            //     }
            // });
            // let arrTable = result.filter(f => !f.isDelete);
            // setDataRowExecutive({
            //     ...dataRow,
            //     nDataLength: arrTable.length,
            //     arrRows: arrTable,
            // });
            // setnExecutiveIDEdit(0);
            // setObjExecutiveIDEdit(null);
            // setarrProjectExecutive(result);
            // onClearFieldExecutive();
            //#endregion
        
            //#region New
            let nExecutiveID = 0;
            let dataRow = DataRowExecutive;
            let arrExecutive = DefaultArrayEmpty(arrProjectExecutive);

            if (nExecutiveIDEdit) //Edit
            {
                const oEditIndex = arrExecutive.findIndex((item) => item.nID === nExecutiveIDEdit);
                if (oEditIndex !== -1) {
                    arrExecutive[oEditIndex].sTitle = ObjForm.sTitle;
                    arrExecutive[oEditIndex].sFName = ObjForm.sFName;
                    arrExecutive[oEditIndex].sLName = ObjForm.sLName;
                    arrExecutive[oEditIndex].sUserName = ObjForm.sTitle + " " + ObjForm.sFName + " " + ObjForm.sLName;
                    arrExecutive[oEditIndex].sPosition = ObjForm.sPosition;
                    arrExecutive[oEditIndex].sPositionAddress = ObjForm.sPositionAddress;
                    arrExecutive[oEditIndex].nProvinceID = Convert.StringToInt(ObjForm.nProvinceID);
                    arrExecutive[oEditIndex].nDistrictID = Convert.StringToInt(ObjForm.nDistrictID);
                    arrExecutive[oEditIndex].nSubDistrictID = Convert.StringToInt(ObjForm.nSubDistrictID);
                    arrExecutive[oEditIndex].sTelNo = ObjForm.sTelNo;
                    arrExecutive[oEditIndex].sEmail = ObjForm.sEmail;
                    arrExecutive[oEditIndex].sLineID = ObjForm.sLineID;
                }
                let arrTable = arrExecutive.filter(f => !f.isDelete);
                setDataRowExecutive({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
            } 
            else //Add
            {            
                let nMaxID = new LINQ<any>(arrExecutive).Any() ? new LINQ<any>(arrExecutive).Max((m) => m.nID) + 1 : 1;               
                let obj = {
                    isDelete: false,
                    isEdit: false, 
                    sID: nMaxID.toString(),
                    nNo: nMaxID,
                    nID: nMaxID,
                    nExecutiveID: nExecutiveID,
                    sTitle: ObjForm.sTitle,
                    sFName: ObjForm.sFName,
                    sLName: ObjForm.sLName,
                    sUserName: ObjForm.sTitle + " " + ObjForm.sFName + " " + ObjForm.sLName,
                    sPosition: ObjForm.sPosition,
                    sPositionAddress: ObjForm.sPositionAddress,
                    nProvinceID: Convert.StringToInt(ObjForm.nProvinceID),
                    nDistrictID: Convert.StringToInt(ObjForm.nDistrictID),
                    nSubDistrictID: Convert.StringToInt(ObjForm.nSubDistrictID),
                    sTelNo: ObjForm.sTelNo,
                    sEmail: ObjForm.sEmail,
                    sLineID: ObjForm.sLineID
                };

                let nNo = 1;
                let result = [...arrExecutive, obj];
                // result.forEach(f => f.nNo = nNo++);
                result.forEach(f => {
                    if (f.isDelete === true) {
                        f.nNo = 0;
                    } else {
                        f.nNo = nNo++;
                    }
                });
                let arrTable = result.filter(f => !f.isDelete);
                setDataRowExecutive({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
                setarrProjectExecutive(result);
            }
            setnExecutiveIDEdit(0);
            setObjExecutiveIDEdit(null);
            onClearFieldExecutive();
            //#endregion
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldExecutive = () => {
        Object.keys(formExecutive.getValues()).forEach((key) => {
            formExecutive.setValue(key, null);
            formExecutive.clearErrors(key);
        });
    };

    const onEditExecutive = (ObjData, nModeID : EnumStatusMode) => {
        onGetDistrict(ObjData.nProvinceID);
        onGetSubDistrict(ObjData.nDistrictID);

        setnExecutiveIDEdit(ObjData.nID);   
        let ObjExecutive = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nExecutiveID: ObjData.nExecutiveID,         
            sTitle: ObjData.sTitle,
            sFName: ObjData.sFName,
            sLName: ObjData.sLName,
            sUserName: ObjData.sUserName,
            sPosition: ObjData.sPosition,
            sPositionAddress: ObjData.sPositionAddress,
            nProvinceID: ObjData.nProvinceID,
            nDistrictID: ObjData.nDistrictID,
            nSubDistrictID: ObjData.nSubDistrictID,
            sTelNo: ObjData.sTelNo,
            sEmail: ObjData.sEmail,
            sLineID: ObjData.sLineID
        };
        setObjExecutiveIDEdit(ObjExecutive);
        formExecutive.setValue("sTitle", ObjExecutive.sTitle);
        formExecutive.setValue("sFName", ObjExecutive.sFName);
        formExecutive.setValue("sLName", ObjExecutive.sLName);
        formExecutive.setValue("sUserName", ObjExecutive.sUserName);
        formExecutive.setValue("sPosition", ObjExecutive.sPosition);
        formExecutive.setValue("sPositionAddress", ObjExecutive.sPositionAddress);
        formExecutive.setValue("nProvinceID", ObjExecutive.nProvinceID);
        formExecutive.setValue("nDistrictID", ObjExecutive.nDistrictID);
        formExecutive.setValue("nSubDistrictID", ObjExecutive.nSubDistrictID);
        formExecutive.setValue("sTelNo", ObjExecutive.sTelNo);
        formExecutive.setValue("sEmail", ObjExecutive.sEmail);
        formExecutive.setValue("sLineID", ObjExecutive.sLineID);

        document.getElementById("myDivExecutive").scrollIntoView({ behavior: "smooth" }); //{ behavior: "smooth", block: "end", inline: "nearest" }
    }

    const onDeleteExecutive = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrExecutiveData: any[] = arrProjectExecutive;
            let result = arrExecutiveData.filter((f) => f.nID !== nID);
            let arrDelete = arrExecutiveData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nNo = 0;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowExecutive({
                ...DataRowExecutive,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectExecutive([...result.filter(f => !f.isDelete), ...arrDelete]);
        });
    };
    //#endregion

    //#region Secondary Unit
    const [nSecondaryUnitIDEdit, setnSecondaryUnitIDEdit] = useState(0);
    const [ObjSecondaryUnitIDEdit, setObjSecondaryUnitIDEdit] = useState(null);
    const [arrProjectSecondaryUnit, setarrProjectSecondaryUnit] = useState([]);
    const [DataRowSecondaryUnit, setDataRowSecondaryUnit] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const onClearFileSecondaryUnit = useRef(null);
    const [arrFileSecondaryUnit, setarrFileSecondaryUnit] = useState([]);

    const formSecondaryUnit = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sUnitName: null,
        } as any,
    });

    const dataColumnSecondaryUnit : any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            {nStatusID !== EnumProjectStatusID.nStatusID_11 &&
                                <BtnDeleteOnTable
                                    key={"btnDelete_SecondaryUnit_" + item.row.sID}
                                    id={"btnDelete_SecondaryUnit_" + item.row.sID}
                                    onClick={() => onDeleteSecondaryUnit(item.row.nID, EnumStatusMode.Delete)}
                                    IsDisabled={!isPermission || isEditSecretary === false}
                                />  
                            }                      
                            <BtnEditOnTable
                                key={"btnEdit_SecondaryUnit_" + item.row.sID}
                                id={"btnEdit_SecondaryUnit_" + item.row.sID}
                                onClick={() => onEditSecondaryUnit(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_SecondaryUnit_" + item.row.sID}
                            id={"btnView_SecondaryUnit_" + item.row.sID}
                            onClick={() => onEditSecondaryUnit(item.row, EnumStatusMode.View)}
                            // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nNo",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sUnitName",
            headerName: "หน่วยงานรอง",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 4,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "lstFileDocument",
            headerName: "ไฟล์แนบ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 5,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                return (
                    <Grid item xs={12} md={12}>
                        <FormProvider {...formSecondaryUnit}>
                            <UploadFileItem
                                required={false}
                                modeDisplay={"list"}
                                id={"oFileDocument"}
                                name={"oFileDocument"}
                                key={item.row.sID}
                                IsDrag={false}
                                arrFile={item.row.lstFileDocument}
                                setarrFile={()=>{}}
                                Extension={["pdf","jpeg", "png"]}
                                IsFolder={false}
                                isFileChange={true}
                                IsMultiple={true}
                                onClearFile={()=>{}}
                                sFolderTemp="Project"
                                nLimitFile={10}
                                sLimitFile="MB"
                                sPositionText="right"
                                IsMultiDelete={false}
                                disabled={true}
                                IsHide={true}
                            />
                        </FormProvider>
                    </Grid>
                );
            },
        },
    ];

    const onAddSecondaryUnit = () => {
        if (arrFileSecondaryUnit.length === 0) { 
            return DialogFn.Warning("กรุณาอัพโหลดไฟล์ข้อมูล");      
        }    

        let ObjForm = formSecondaryUnit.getValues();
        let ObjDuplicate = arrProjectSecondaryUnit.filter((f) => !f.isDelete && (nSecondaryUnitIDEdit !== 0 ? f.nID !== nSecondaryUnitIDEdit : true) && f.sUnitName === ObjForm.sUnitName );
        if ((ObjDuplicate || []).length === 0)
        {      
            //#region Old
            // let nSecondaryUnitID = 0;
            // let dataRow = DataRowSecondaryUnit;
            // let arrSecondaryUnit = DefaultArrayEmpty(arrProjectSecondaryUnit);
            // let nMaxID = new LINQ<any>(arrSecondaryUnit).Any() ? new LINQ<any>(arrSecondaryUnit).Max((m) => m.nID) + 1 : 1;
            // if (nSecondaryUnitIDEdit) {
            //     arrSecondaryUnit = arrSecondaryUnit.filter((f) => f.nID !== nSecondaryUnitIDEdit);
            //     nSecondaryUnitID = arrProjectSecondaryUnit.find((f) => f.nID === nSecondaryUnitIDEdit)?.nSecondaryUnitID;
            //     nMaxID = nSecondaryUnitIDEdit;
            // }
            // let obj = {
            //     isDelete: false,
            //     isEdit: false, 
            //     sID: nMaxID.toString(),
            //     nNo: nMaxID,
            //     nID: nMaxID,
            //     nSecondaryUnitID: nSecondaryUnitID,
            //     sUnitName: ObjForm.sUnitName,
            //     lstFileDocument: arrFileSecondaryUnit,
            // };

            // let nNo = 1;
            // let result = [...arrSecondaryUnit, obj];
            // // result.forEach(f => f.nNo = nNo++);
            // result.forEach(f => {
            //     if (f.isDelete === true) {
            //         f.nNo = 0;
            //     } else {
            //         f.nNo = nNo++;
            //     }
            // });
            // let arrTable = result.filter(f => !f.isDelete);
            // setDataRowSecondaryUnit({
            //     ...dataRow,
            //     nDataLength: arrTable.length,
            //     arrRows: arrTable,
            // });
            // setnSecondaryUnitIDEdit(0);
            // setObjSecondaryUnitIDEdit(null);
            // setarrProjectSecondaryUnit(result);
            // onClearFieldSecondaryUnit();
            //#endregion

            //#region New
            let nSecondaryUnitID = 0;
            let dataRow = DataRowSecondaryUnit;
            let arrSecondaryUnit = DefaultArrayEmpty(arrProjectSecondaryUnit);

            if (nSecondaryUnitIDEdit) //Edit
            {
                const oEditIndex = arrSecondaryUnit.findIndex((item) => item.nID === nSecondaryUnitIDEdit);
                if (oEditIndex !== -1) {
                    arrSecondaryUnit[oEditIndex].sUnitName = ObjForm.sUnitName;
                    arrSecondaryUnit[oEditIndex].lstFileDocument = arrFileSecondaryUnit;
                }
                let arrTable = arrSecondaryUnit.filter(f => !f.isDelete);
                setDataRowSecondaryUnit({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
            } 
            else //Add
            {  
                let nMaxID = new LINQ<any>(arrSecondaryUnit).Any() ? new LINQ<any>(arrSecondaryUnit).Max((m) => m.nID) + 1 : 1;                
                let obj = {
                    isDelete: false,
                    isEdit: false, 
                    sID: nMaxID.toString(),
                    nNo: nMaxID,
                    nID: nMaxID,
                    nSecondaryUnitID: nSecondaryUnitID,
                    sUnitName: ObjForm.sUnitName,
                    lstFileDocument: arrFileSecondaryUnit,
                };

                let nNo = 1;
                let result = [...arrSecondaryUnit, obj];
                // result.forEach(f => f.nNo = nNo++);
                result.forEach(f => {
                    if (f.isDelete === true) {
                        f.nNo = 0;
                    } else {
                        f.nNo = nNo++;
                    }
                });
                let arrTable = result.filter(f => !f.isDelete);
                setDataRowSecondaryUnit({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
                setarrProjectSecondaryUnit(result);
            }
            setnSecondaryUnitIDEdit(0);
            setObjSecondaryUnitIDEdit(null);
            onClearFieldSecondaryUnit();
            //#endregion
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldSecondaryUnit = () => {
        Object.keys(formSecondaryUnit.getValues()).forEach((key) => {
            formSecondaryUnit.setValue(key, null);
            formSecondaryUnit.clearErrors(key);
        });
        setarrFileSecondaryUnit([]);
        onClearFileSecondaryUnit.current();
    };

    const onEditSecondaryUnit = (ObjData, nModeID : EnumStatusMode) => {
        setarrFileSecondaryUnit([]);
        onClearFileSecondaryUnit.current();

        setnSecondaryUnitIDEdit(ObjData.nID);   
        let ObjSecondaryUnit = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nSecondaryUnitID: ObjData.nSecondaryUnitID,
            sUnitName: ObjData.sUnitName,
            lstFileDocument: ObjData.lstFileDocument,         
        };
        setObjSecondaryUnitIDEdit(ObjSecondaryUnit);        
        formSecondaryUnit.setValue("sUnitName", ObjSecondaryUnit.sUnitName);
        setarrFileSecondaryUnit(ObjSecondaryUnit.lstFileDocument);

        document.getElementById("myDivSecondaryUnit").scrollIntoView({ behavior: "smooth"});
    }

    const onDeleteSecondaryUnit = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrSecondaryUnitData: any[] = arrProjectSecondaryUnit;
            let result = arrSecondaryUnitData.filter((f) => f.nID !== nID);
            let arrDelete = arrSecondaryUnitData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nNo = 0;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowSecondaryUnit({
                ...DataRowSecondaryUnit,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectSecondaryUnit([...result.filter(f => !f.isDelete), ...arrDelete]);
        });
    };
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        let ObjForm = form.getValues();  
        let ObjFormDocument = formDocument.getValues();  
        // let ObjFormExecutive = formExecutive.getValues();  
        // let ObjFormSecondaryUnit = formSecondaryUnit.getValues();  
        if (nModeID === EnumSaveModeProject.Submit)
        {
            if (arrProjectExecutive.filter(f => !f.isDelete).length === 0) {
                return DialogFn.Warning("กรุณากรอกข้อมูล รายชื่อผู้บริหารโครงการ กรอกอย่างน้อย 1 คน");
            }

            //เช็คไฟล์ที่ ต้องอัพทั้งหมด
            let isFile = false;
            let sMessageFileAll = "กรุณาอัพโหลดไฟล์ข้อมูล";
            if (arrFile_1.length === 0) {
                isFile = true;
                sMessageFileAll += "<br/> - แนบเอกสาร หนังสือขอรับการสนับสนุนเงินช่วยเหลือหรืออุดหนุนจากกองทุนจัดการซากดึกดำบรรพ";
            }             
            if (arrFile_2.length === 0) {
                isFile = true;
                sMessageFileAll += "<br/> - แนบเอกสาร แบบคำขอเงินช่วยเหลือ หรืออุดหนุนจากกองทุนจัดการซากดึกดำบรรพ์ (แบบ กท. 1/กท. 2)";
            } 
            if (arrFile_4.length === 0 && isFundOwnership_sFundOwnership === false) {
                isFile = true;
                sMessageFileAll += "<br/> - หนังสือแจ้งผลขออนุญาตจากเจ้าของพื้นที";
            } 
            if (arrFile_7.length === 0 && ObjForm.nUnitTypeID !== 81) {
                isFile = true;
                sMessageFileAll += "<br/> - สำเนาบัตรประจำตัวประชาชน หรือบัตรประจำตัวเจ้าหน้าที่รัฐ หรือใบอนุญาตขับรถ หรือ หนังสือเดินทาง หรือบัตรอื่นซึ่งทางราชการเป็นผู้ออกให้ ซึ่งมีรูปถ่าย ลายมือชื่อ และเลขบัตรประจำตัวประชาชน 13 หลักชัดเจน ของผู้มอบอำนาจ และผู้รับมอบอำนาจ พร้อมทั้งรับรองสำเนาถูกต้อง คนละ 1 ฉบับ";
            } 
            if (arrFile_8.length === 0 && ObjForm.nUnitTypeID !== 81) {
                isFile = true;
                sMessageFileAll += "<br/> - สำเนาเอกสารที่แสดงถึงการจัดตั้งให้มีสถานะเป็นนิติบุคคลของเจ้าของโครงการ หรือผู้มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน";
            } 
            if (arrFile_5.length === 0 && isFile_5_isDocumentTor === true) {
                isFile = true;
                sMessageFileAll += "<br/> - ข้อกำหนดและขอบเขตงาน (TOR) และ/หรือใบเสนอราคา จำนวน 3 ราย ในกรณีที่มีการดำเนินงานที่ต้องจัดซื้อจัดจ้าง หรือใบเสนอราคา จำนวน 1 ราย ในกรณีที่มีการจัดซื้อจัดจ้างเฉพาะเจาะจง";
            } 
            if (arrFile_6.length === 0 && isFile_6_isPriceReference === true) {
                isFile = true;
                sMessageFileAll += "<br/> - เกณฑ์อ้างอิงราคา (ถ้ามี)";
            } 
            if (arrFile_9.length === 0 && isFile_9_isPowerOfAttorney === true && ObjForm.nUnitTypeID !== 81) {
                isFile = true;
                sMessageFileAll += "<br/> - หนังสือมอบอำนาจปฏิบัติราชการแทน";
            } 
            if (arrProjectSecondaryUnit.filter(f => !f.isDelete).length === 0 && isFile_10_isIntegrationUnit === true) {
                isFile = true;
                sMessageFileAll += "<br/> - กรุณากรอกข้อมูล กรณีที่โครงการมีผู้เข้าร่วมโครงการจากหน่วยงานอื่นที่ไม่ใช่หน่วยงานเดียวกับเจ้าของโครงการ ให้มีเอกสารจากหน่วยงานต้นสังกัดที่ยินยอมให้ผู้เข้าร่วมโครงการดำเนินโครงการ";
            } 

            if (isFile) { 
                return DialogFn.Warning(sMessageFileAll);      
            }     
        }

        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel0,
            isFastTrack: isFastTrack,
    
            sProjectName: ObjForm.sProjectName,
            nSectionID: ObjForm.nSectionID,
            nOperationTypeID: ObjForm.nOperationTypeID,
            sOperationOther: ObjForm.sOperationOther ?? null,
            nUnitTypeID: ObjForm.nUnitTypeID,    
            sUnitOwnerName: ObjForm.sUnitOwnerName,
            lstProjectExecutive: arrProjectExecutive,    
            isFundOwnership: ObjFormDocument.isFundOwnership === "Y",
            sFundOwnership: ObjFormDocument.sFundOwnership ?? null,
            isDocumentTor: ObjFormDocument.isDocumentTor === "Y",
            isPriceReference: ObjFormDocument.isPriceReference === "Y",
            isPowerOfAttorney: ObjFormDocument.isPowerOfAttorney === "Y",    
            lstFileDocument_1: arrFile_1,
            lstFileDocument_2: arrFile_2,
            lstFileDocument_3: arrFile_3,
            lstFileDocument_4: arrFile_4,
            lstFileDocument_5: arrFile_5,
            lstFileDocument_6: arrFile_6,
            lstFileDocument_7: ObjForm.nUnitTypeID !== 81 ? arrFile_7 : [],
            lstFileDocument_8: ObjForm.nUnitTypeID !== 81 ? arrFile_8 : [],  
            lstFileDocument_9: ObjForm.nUnitTypeID !== 81 ? arrFile_9 : [],  
            isIntegrationUnit: ObjFormDocument.isIntegrationUnit === "Y",
            lstProjectSecondaryUnit: ObjFormDocument.isIntegrationUnit === "Y" ? arrProjectSecondaryUnit : [], 

            sLocation: location.pathname,
        };
        // console.log("Submit SaveProjectPanel 0  ", param);        
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel0, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 0, isEdit: false});
                        setisChangePanel9(true);
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const onClearField = () => {
        Object.keys(form.getValues()).forEach((key) => {
            form.setValue(key, null);
            form.clearErrors(key);
        });
        Object.keys(formDocument.getValues()).forEach((key) => {
            formDocument.setValue(key, null);
            formDocument.clearErrors(key);
        });

        onClearFieldExecutive();
        onClearFieldSecondaryUnit();
    };

    const onExample = (ObjExampleFile) => {
        // โหลดไฟล์เปิดมาอีกแท็บ
        // sExampleFile_1 //Example_Panel0_File_2 = 13, // เงื่อนไขการเลือกประเภทโครงการ >> (ตัวอย่างไฟล์ กท.1 > ข้อมูลผู้ขอรับทุน Panel 0)            
        // sExampleFile_2 nUnitTypeID == 81 //Example_Panel0_File_3 = 14, // ตัวอย่างเอกสาร หน่วยงาน ภายใน >> (ตัวอย่างไฟล์ กท.1 > ข้อมูลผู้ขอรับทุน > หน่วยงาน ภายใน กรมทรัพยากรธรณี Panel 0)
        // sExampleFile_3 nUnitTypeID != 81 //Example_Panel0_File_4 = 15, // ตัวอย่างเอกสาร หน่วยงาน ภายนอก >> (ตัวอย่างไฟล์ กท.1 > ข้อมูลผู้ขอรับทุน > หน่วยงาน ภายนอก  ที่ไม่ใช่ กรมทรัพยากรธรณี คือนอกทั้งหมด  Panel 0)
        
        if(ObjExampleFile?.sPathFile && ObjExampleFile?.sFileName) {
            // downloadFile(ObjExampleFile?.sPathFile, ObjExampleFile?.sFileName);
            // let newWindow = window.open(ObjExampleFile?.sPathFile, "_blank", 'noopener,noreferrer');
            // newWindow.opener = null;
            window.open(ObjExampleFile?.sPathFile, "_blank", 'noopener,noreferrer');
        }
    }

    const onDownloadWord = async () => {
        //Word
        DialogFn.BlockUI();
        // let param = {nProjectID: nProjectID,}
        // let sProjectName = "แบบฟอร์มขอรับการสนับสนุน_รายงานผลโครงการ";
        // let sFileName = `Project_${sProjectName}_${moment().format('yyyyMMDDHHmmss')}.docx`;
        let param = {
            sKeyID: nProjectID+"",
            nProjectVersionID: nProjectVersionID === 0 ? null : nProjectVersionID,
        }
        let nYearThai = parseInt(moment().format('YYYY')) + 543;
        let sFileName = `แบบ กท.1 กท.2 ${moment().format('DMMM')}${nYearThai}.docx`;
        AxiosFn.DowloadFileBlob(ApiProject.ExportProjectWord, param, sFileName, () => {
            DialogFn.UnBlockUI();
        });
    }
    
    return (
        <AccordionPanel
            header={"ข้อมูลผู้ขอรับทุน"}
            isExpanded={false} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />
                )
            }
        >
            <Grid id={"myDivPanel0"} item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                <Grid item xs={12} md={12} container spacing={2}>
                    <Grid item xs={12} md={12} style={{ textAlign: 'center'}}>
                        <Typography variant='h6' color={'#0000a5'}>แบบคำขอเงินช่วยเหลือหรืออุดหนุนจากกองทุนจัดการซากดึกดำบรรพ์</Typography>
                    </Grid>                        
                    <FormProvider {...form}>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                            <Grid item xs={12} md={12}>
                                <TextBoxItem
                                    id={"sProjectName"}
                                    name={"sProjectName"}
                                    type={"text"}
                                    label={"ชื่อโครงการ"}
                                    placeholder={"ชื่อต้องสั้น กระชับ ได้ใจความ และสื่อถึงวัตถุประสงค์/เป้าหมายชัดเจน และระบุพื้นที่โครงการ"}
                                    required={true}
                                    maxLength={500}
                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : (isModeSecretary === true && (nStatusID === EnumProjectStatusID.nStatusID_9 || nStatusID === EnumProjectStatusID.nStatusID_10)) ? true : (!isPermission || isEditSecretary === false)}
                                />
                            </Grid> 
                            <Grid item xs={12} md={12} container alignItems="center">
                                <Grid item md={2}>
                                    <HeaderInput text={"ประเภทโครงการ"} required={true}/>
                                </Grid> 
                                <Grid item md={10} container justifyContent="end">
                                    <BtnExample id={"BtnExample_1"} txt={"เงื่อนไขการเลือกประเภทโครงการ"} onClick={(e) => { onExample(ObjExampleFile_1) }} icon={<SettingsSuggest />} />
                                </Grid> 
                                <Grid item xs={12} md={12}>
                                    <RadioListItem
                                        id={"nSectionID"}
                                        name={"nSectionID"}
                                        label={"ประเภทโครงการ"}
                                        IsNotShowLabel={true}
                                        required={true}
                                        options={arrDataSectionTypeID}    
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : (isModeSecretary === true && (nStatusID === EnumProjectStatusID.nStatusID_9 || nStatusID === EnumProjectStatusID.nStatusID_10)) ? true : (!isPermission || isEditSecretary === false)}  
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={6}>
                                    <SelectItem
                                        id="nOperationTypeID"
                                        name="nOperationTypeID"
                                        options={arrDataOperationType}
                                        label={"ลักษณะการดำเนินงาน"}
                                        required={true}
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : (isModeSecretary === true && (nStatusID === EnumProjectStatusID.nStatusID_9 || nStatusID === EnumProjectStatusID.nStatusID_10)) ? true : (!isPermission || isEditSecretary === false)}
                                        onChange={(e)=> { if(e === null || e?.value !== 80) form.setValue("sOperationOther", null); }}  
                                    />
                                </Grid>
                                {form.watch("nOperationTypeID") === 80 && 
                                    <Grid item xs={12} md={6}>
                                        <TextBoxItem
                                            id={"sOperationOther"}
                                            name={"sOperationOther"}
                                            type={"text"}
                                            label={"อื่นๆ"}
                                            required={form.watch("nOperationTypeID") === 80}
                                            maxLength={250}
                                            disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : (isModeSecretary === true && (nStatusID === EnumProjectStatusID.nStatusID_9 || nStatusID === EnumProjectStatusID.nStatusID_10)) ? true : ((form.watch("nOperationTypeID") !== 80 || form.watch("nOperationTypeID") === null) || !isPermission || isEditSecretary === false)}
                                        />
                                    </Grid>
                                }
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={6}>
                                    <SelectItem
                                        id="nUnitTypeID"
                                        name="nUnitTypeID"
                                        options={arrDataUnitType}
                                        label={"ประเภทหน่วยงาน"}
                                        required={true}
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : (isModeSecretary === true && (nStatusID === EnumProjectStatusID.nStatusID_9 || nStatusID === EnumProjectStatusID.nStatusID_10)) ? true : (!isPermission || isEditSecretary === false)}  
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextBoxItem
                                        id={"sUnitOwnerName"}
                                        name={"sUnitOwnerName"}
                                        type={"text"}
                                        label={"เจ้าของโครงการ (หน่วยงาน)"}
                                        required={true}
                                        maxLength={250}
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : (isModeSecretary === true && (nStatusID === EnumProjectStatusID.nStatusID_9 || nStatusID === EnumProjectStatusID.nStatusID_10)) ? true : (!isPermission || isEditSecretary === false)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>   
                        <Grid item xs={12} md={12} container spacing={2}  style={{ paddingBottom: '1%', }}>
                            <AccordionPanel
                                header={"รายชื่อผู้บริหารโครงการ"}
                                isExpanded={false} 
                                color="white"
                                bgColor="rgb(102,151,245)"
                                background="#e79a09"
                                expandIconColor="white"
                                borderColor="1px solid #e79a09"
                                borderRadius="20px !important"
                                boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                                SubHeaderStatus={<Typography color={'#9f0000'}>{"(กรอกอย่างน้อย 1 คน)"}</Typography>}
                                sStyleSubHeader={"start"}
                            >           
                                <div id='myDivExecutive'>
                                    <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '2%', }}>
                                        <FormProvider {...formExecutive}>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={4}>
                                                    <TextBoxItem
                                                        id={"sTitle"}
                                                        name={"sTitle"}
                                                        type={"text"}
                                                        label={"คำนำหน้า"}
                                                        required={true}
                                                        maxLength={50}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextBoxItem
                                                        id={"sFName"}
                                                        name={"sFName"}
                                                        type={"text"}
                                                        label={"ชื่อ"}
                                                        required={true}
                                                        maxLength={50}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextBoxItem
                                                        id={"sLName"}
                                                        name={"sLName"}
                                                        type={"text"}
                                                        label={"นามสกุล"}
                                                        required={true}
                                                        maxLength={50}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={4}>
                                                    <TextBoxItem
                                                        id={"sPosition"}
                                                        name={"sPosition"}
                                                        type={"text"}
                                                        label={"ตำแหน่ง (ต้นสังกัด)"}
                                                        required={true}
                                                        maxLength={250}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={8}>
                                                    <TextBoxItem
                                                        id={"sPositionAddress"}
                                                        name={"sPositionAddress"}
                                                        type={"text"}
                                                        label={"ที่อยู่ (หน่วยงานต้นสังกัด)"}
                                                        required={false}
                                                        maxLength={500}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={4}>
                                                    <SelectItem
                                                        id="nProvinceID"
                                                        name="nProvinceID"
                                                        options={arrDataProvince}
                                                        label={"จังหวัด"}
                                                        placeholder="เลือกจังหวัด"
                                                        required={true}
                                                        onChange={(e) => {
                                                            onGetDistrict(e?.value);
                                                        }}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <SelectItem
                                                        id="nDistrictID"
                                                        name="nDistrictID"
                                                        options={arrDataDistrict}
                                                        label={"อำเภอ"}
                                                        placeholder="เลือกอำเภอ"
                                                        required={true}
                                                        onChange={(e) => {
                                                            onGetSubDistrict(e?.value);
                                                        }}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <SelectItem
                                                        id="nSubDistrictID"
                                                        name="nSubDistrictID"
                                                        options={arrDataSubDistrict}
                                                        label={"ตำบล"}
                                                        placeholder="เลือกตำบล"
                                                        required={true}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '2%', }}>
                                                <Grid item xs={12} md={4}>
                                                    <TextBoxItem
                                                        id={"sTelNo"}
                                                        name={"sTelNo"}
                                                        type={'text'}
                                                        label={"เบอร์โทรศัพท์"}
                                                        isTelNo={true}
                                                        maxLength={10}
                                                        required={true}
                                                        pattern={'en-number'}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                    {/* <InputNumberItem
                                                        id={"sTelNo"}
                                                        name={"sTelNo"}
                                                        label={"เบอร์โทรศัพท์"}
                                                        IsComma={false}
                                                        IsCanMinus={false}
                                                        IsAllowScientific={false}
                                                        type={"Number"}
                                                        ShowDigits={0}
                                                        maxDigits={0}
                                                        maxInteger={10}
                                                        maxLength={10}
                                                        IsLeadingZero={true}
                                                        required={true}
                                                        textAlign={'left'}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    /> */}
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextBoxItem
                                                        id={"sEmail"}
                                                        name={"sEmail"}
                                                        type={"email"}
                                                        label={"อีเมล"}
                                                        required={true}
                                                        maxLength={250}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextBoxItem
                                                        id={"sLineID"}
                                                        name={"sLineID"}
                                                        type={"text"}
                                                        label={"Line ID"}
                                                        required={false}
                                                        maxLength={50}
                                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={12} container spacing={1}>
                                                    <Grid item xs={12} md={8}>
                                                        <Typography variant='body2' color={'red'}>หมายเหตุ : กรณีที่เป็นโครงการร่วมหลายหน่วยงาน สามารถเพิ่มเติมผู้รับผิดชอบโครงการได้</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4} container spacing={1} justifyContent="end">
                                                        {(nExecutiveIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                            (nStatusID !== EnumProjectStatusID.nStatusID_11 &&
                                                                <BtnAdd id={"btnAdd_Table_Executive"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่ม"} onClick={formExecutive.handleSubmit((e) => onAddExecutive(),(err) => console.log("err", err))} />
                                                            )
                                                            :
                                                            <>
                                                                {(nStatusID !== EnumProjectStatusID.nStatusID_11 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) &&
                                                                    <Grid item>
                                                                        <BtnSave id={"btnSave_Table_Executive"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formExecutive.handleSubmit((e) => onAddExecutive(),(err) => console.log("err", err))} />
                                                                    </Grid>
                                                                }
                                                                {nExecutiveIDEdit !== 0 &&
                                                                    <Grid item>
                                                                        <BtnCancel id={"btnCancel_Table_Executive"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnExecutiveIDEdit(0); setObjExecutiveIDEdit(null); onClearFieldExecutive(); }} />
                                                                    </Grid>  
                                                                }                
                                                            </>
                                                        }
                                                    </Grid>
                                                </Grid>                                          
                                                <Grid item xs={12} md={12}>
                                                    <DataGrid
                                                        sTableID='TB_Project_Panel0_Executive'
                                                        columns={dataColumnExecutive}
                                                        rows={DataRowExecutive}
                                                        isShowColomnTool={false}
                                                        isHiddenToolHead={true}
                                                        isShowCheckBox={false}
                                                        isHiddenPagination={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </FormProvider>  
                                    </Grid>
                                </div>
                            </AccordionPanel>
                        </Grid>            
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <AccordionPanel
                                header={"รายการเอกสารที่ผู้ขอรับการสนับสนุนจากกองทุนจัดการซากดึกดำบรรพ์ที่ต้องดำเนินการจัดส่งผ่านระบบออนไลน์"}
                                isExpanded={false} 
                                color="white"
                                bgColor="rgb(102,151,245)"
                                background="#e79a09"
                                expandIconColor="white"
                                borderColor="1px solid #e79a09"
                                borderRadius="20px !important"
                                boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                            >     
                                <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                    <FormProvider {...formDocument}>
                                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '2%', }}>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={10} container spacing={1} justifyContent="start">
                                                    <Grid item>
                                                        <Typography variant='body1' color={'blue'}>แนบเอกสาร หนังสือขอรับการสนับสนุนเงินช่วยเหลือหรืออุดหนุนจากกองทุนจัดการซากดึกดำบรรพ์</Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant='body1' color={'red'}>*</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={2} container spacing={1} justifyContent="end">
                                                    <BtnExample id={"BtnExample_23"} txt={"ตัวอย่างเอกสาร"} onClick={(e) => { onExample( form.getValues("nUnitTypeID") === 81 ? ObjExampleFile_2 : ObjExampleFile_3) }} icon={<Description/>}/>
                                                </Grid>                     
                                            </Grid>                                           
                                            <Grid item xs={12} md={12}>
                                                <UploadFileItem
                                                    required={true}
                                                    modeDisplay={"list"}
                                                    id={"arrFile_1"}
                                                    name={"arrFile_1"}
                                                    label={""}
                                                    arrFile={arrFile_1}
                                                    setarrFile={setarrFile_1}
                                                    Extension={["pdf","jpeg", "png"]}                                                    
                                                    IsFolder={false}
                                                    onClearFile={onClearFile_1}
                                                    sFolderTemp="Project"
                                                    IsMultiple={false}
                                                    nLimitFile={10}
                                                    sLimitFile="MB"
                                                    sPositionText="right"
                                                    IsCrop={true}
                                                    cropShape={"retangle"}
                                                    cropRatio={16 / 9}
                                                    cropResize={true}
                                                    cropMovable={true}
                                                    isRequiredLimitFile={true}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                            <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }}/>
                                        </Grid>  
                                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={10} container spacing={1} justifyContent="start">
                                                    <Grid item>
                                                        <Typography variant='body1' color={'blue'}>แนบเอกสาร แบบคำขอเงินช่วยเหลือ หรืออุดหนุนจากกองทุนจัดการซากดึกดำบรรพ์ (แบบ กท. 1/กท. 2)</Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant='body1' color={'red'}>*</Typography>
                                                    </Grid>                                                                  
                                                </Grid>  
                                                <Grid item xs={12} md={2} container spacing={1} justifyContent="end">
                                                    {isComplete !== null && <BtnDownload id={"btnDownload"} txt={"ดาวน์โหลด"} IsDisabled={isComplete === null} onClick={onDownloadWord} icon={<Description/>}/>}
                                                    {/* (isComplete !== null && (isPermission || isEditSecretary === true))  */}
                                                </Grid>      
                                            </Grid>                                          
                                            <Grid item xs={12} md={12} style={{ paddingBottom: '2%', }}>
                                                <UploadFileItem
                                                    required={true}
                                                    modeDisplay={"list"}
                                                    id={"arrFile_2"}
                                                    name={"arrFile_2"}
                                                    label={""}
                                                    arrFile={arrFile_2}
                                                    setarrFile={setarrFile_2}
                                                    Extension={["pdf","jpeg", "png"]}
                                                    IsFolder={false}
                                                    onClearFile={onClearFile_2}
                                                    sFolderTemp="Project"
                                                    IsMultiple={false}
                                                    nLimitFile={10}
                                                    sLimitFile="MB"
                                                    sPositionText="right"
                                                    IsCrop={true}
                                                    cropShape={"retangle"}
                                                    cropRatio={16 / 9}
                                                    cropResize={true}
                                                    cropMovable={true}
                                                    isRequiredLimitFile={true}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2' color={'red'}>กรุณาลงนามโดยผู้มีอำนาจ และแนบไฟล์กลับเข้าระบบ</Typography>
                                            </Grid>   
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                            <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }}/>
                                        </Grid>  
                                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                                            <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                                <Typography variant='body1' color={'blue'}>หนังสือขออนุญาตเข้าและดำเนินงานในพื้นที่จากเจ้าของพื้นที่ ในกรณีมีการดำเนินงานโครงการที่มิใช่พื้นที่ในกรรมสิทธิ์ของหน่วยงานของผู้ขอเงินช่วยเหลือหรืออุดหนุน หรือในอำนาจอนุรักษ์คุ้มครองตามระเบียบ/กฎหมายของหน่วยงานราชการอื่น</Typography>                                                        
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <RadioListItem
                                                    id={"isFundOwnership"}
                                                    name={"isFundOwnership"}
                                                    label={"พื้นที่โครงการอยู่ในกรรมสิทธิ์หรือในอำนาจของหน่วยงานของผู้ขอเงินช่วยเหลือหรืออุดหนุนหรือไม่"}
                                                    IsNotShowLabel={false}
                                                    required={true}
                                                    options={OptionsProjectStatus_1}    
                                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                    // row={false}
                                                    onChange={(e)=> {
                                                        setisFundOwnership_sFundOwnership(e === "Y");
                                                    }}
                                                />
                                            </Grid>     
                                            <Grid item xs={12} md={12} >
                                                <TextAreaItem
                                                    id={"sFundOwnership"}
                                                    name={"sFundOwnership"}
                                                    label={"กรณีที่เป็นพื้นที่ในกรรมสิทธิ์หรือในอำนาจของหลายหน่วยงานโปรดระบุให้ครบถ้วน"}                               
                                                    required={isFundOwnership_sFundOwnership}
                                                    maxLength={500}
                                                    row={3}
                                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body1' color={"rgba(0, 0, 0, 0.6)"}>แนบเอกสารหนังสือขอเข้าพื้นที่</Typography>                  
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <UploadFileItem
                                                        required={false}
                                                        modeDisplay={"list"}
                                                        id={"arrFile_3"}
                                                        name={"arrFile_3"}
                                                        label={""}
                                                        arrFile={arrFile_3}
                                                        setarrFile={setarrFile_3}
                                                        Extension={["pdf","jpeg", "png"]}
                                                        IsFolder={true}
                                                        onClearFile={onClearFile_3}
                                                        sFolderTemp="Project"
                                                        IsMultiple={true}
                                                        nLimitFile={10}
                                                        sLimitFile="MB"
                                                        sPositionText="right"
                                                        IsCrop={true}
                                                        cropShape={"retangle"}
                                                        cropRatio={16 / 9}
                                                        cropResize={true}
                                                        cropMovable={true}
                                                        isRequiredLimitFile={true}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                <Grid item xs={12} md={12} container spacing={1}>
                                                    <Grid item>
                                                        <Typography variant='body1' color={"rgba(0, 0, 0, 0.6)"}>หนังสือแจ้งผลขออนุญาตจากเจ้าของพื้นที่</Typography>
                                                    </Grid>
                                                    {isFundOwnership_sFundOwnership === false &&
                                                        <Grid item>
                                                            <Typography variant='body1' color={'red'}>*</Typography>
                                                        </Grid>
                                                    }                  
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <UploadFileItem
                                                        required={!isFundOwnership_sFundOwnership}
                                                        modeDisplay={"list"}
                                                        id={"arrFile_4"}
                                                        name={"arrFile_4"}
                                                        label={""}
                                                        arrFile={arrFile_4}
                                                        setarrFile={setarrFile_4}
                                                        Extension={["pdf","jpeg", "png"]}
                                                        IsFolder={true}
                                                        onClearFile={onClearFile_4}
                                                        sFolderTemp="Project"
                                                        IsMultiple={true}
                                                        nLimitFile={10}
                                                        sLimitFile="MB"
                                                        sPositionText="right"
                                                        IsCrop={true}
                                                        cropShape={"retangle"}
                                                        cropRatio={16 / 9}
                                                        cropResize={true}
                                                        cropMovable={true}
                                                        isRequiredLimitFile={true}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                            <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }}/>
                                        </Grid>            
                                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '2%', }}>
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body1' color={'blue'}>ข้อกำหนดและขอบเขตงาน (TOR) และ/หรือใบเสนอราคา จำนวน 3 ราย ในกรณีที่มีการดำเนินงานที่ต้องจัดซื้อจัดจ้าง หรือใบเสนอราคา จำนวน 1 ราย ในกรณีที่มีการจัดซื้อจัดจ้างเฉพาะเจาะจง</Typography>                                                        
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <RadioListItem
                                                    id={"isDocumentTor"}
                                                    name={"isDocumentTor"}
                                                    label={""}
                                                    IsNotShowLabel={true}
                                                    required={false}
                                                    options={OptionsProjectStatus_2}    
                                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                    // row={false}
                                                    onChange={(e)=> {
                                                        setisFile_5_isDocumentTor(e === "Y");
                                                    }}
                                                />                                                  
                                            </Grid>
                                            {isFile_5_isDocumentTor &&
                                                <Grid item xs={12} md={12}>
                                                    <UploadFileItem
                                                        required={isFile_5_isDocumentTor}
                                                        modeDisplay={"list"}
                                                        id={"arrFile_5"}
                                                        name={"arrFile_5"}
                                                        label={!isFile_5_isDocumentTor ? "" : "ถ้า มี บังคับแนบไฟล์เอกสาร"}
                                                        arrFile={arrFile_5}
                                                        setarrFile={setarrFile_5}
                                                        Extension={["pdf","jpeg", "png"]}
                                                        IsFolder={true}
                                                        onClearFile={onClearFile_5}
                                                        sFolderTemp="Project"
                                                        IsMultiple={true}
                                                        nLimitFile={10}
                                                        sLimitFile="MB"
                                                        sPositionText="right"
                                                        IsCrop={true}
                                                        cropShape={"retangle"}
                                                        cropRatio={16 / 9}
                                                        cropResize={true}
                                                        cropMovable={true}
                                                        isRequiredLimitFile={true}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                            <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }}/>
                                        </Grid>           
                                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '2%', }}>
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body1' color={'blue'}>เกณฑ์อ้างอิงราคา (ถ้ามี)</Typography>                                                        
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <RadioListItem
                                                    id={"isPriceReference"}
                                                    name={"isPriceReference"}
                                                    label={""}
                                                    IsNotShowLabel={true}
                                                    required={false}
                                                    options={OptionsProjectStatus_3}    
                                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                    // row={false}
                                                    onChange={(e)=> {
                                                        setisFile_6_isPriceReference(e === "Y");
                                                    }}
                                                />                                                  
                                            </Grid>
                                            {isFile_6_isPriceReference &&
                                                <Grid item xs={12} md={12}>
                                                    <UploadFileItem
                                                        required={isFile_6_isPriceReference}
                                                        modeDisplay={"list"}
                                                        id={"arrFile_6"}
                                                        name={"arrFile_6"}
                                                        label={!isFile_6_isPriceReference ? "" : "ถ้า เฉพาะเจาะจง บังคับแนบไฟล์เอกสาร"}
                                                        arrFile={arrFile_6}
                                                        setarrFile={setarrFile_6}
                                                        Extension={["pdf","jpeg", "png"]}
                                                        IsFolder={true}
                                                        onClearFile={onClearFile_6}
                                                        sFolderTemp="Project"
                                                        IsMultiple={true}
                                                        nLimitFile={10}
                                                        sLimitFile="MB"
                                                        sPositionText="right"
                                                        IsCrop={true}
                                                        cropShape={"retangle"}
                                                        cropRatio={16 / 9}
                                                        cropResize={true}
                                                        cropMovable={true}
                                                        isRequiredLimitFile={true}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                            <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }}/>
                                        </Grid>   
                                        {form.watch("nUnitTypeID") !== 81 &&
                                            <>
                                                <Grid item xs={12} md={12} container spacing={3} style={{ paddingBottom: '2%', }}>
                                                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                                        <Typography variant='body1' color={'blue'}>กรณีที่เจ้าของโครงการ หรือผู้มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน เป็นผู้รับมอบอำนาจต้องแนบหนังสือมอบอำนาจ และปิดอากรแสตมป์ ตามประมวลกฎหมายรัษฎากรกำหนด หรือเอกสารที่เกี่ยวกับการมอบหมายอำนาจหน้าที่ตามกฎหมาย พร้อมเอกสารที่เกี่ยวข้อง ดังนี้</Typography>                                                        
                                                    </Grid>
                                                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                        <Grid item xs={12} md={12} container spacing={1}>
                                                            <HeaderInput
                                                                text={"สำเนาบัตรประจำตัวประชาชน หรือบัตรประจำตัวเจ้าหน้าที่รัฐ หรือใบอนุญาตขับรถ หรือ หนังสือเดินทาง หรือบัตรอื่นซึ่งทางราชการเป็นผู้ออกให้ ซึ่งมีรูปถ่าย ลายมือชื่อ และเลขบัตรประจำตัวประชาชน 13 หลักชัดเจน ของผู้มอบอำนาจ และผู้รับมอบอำนาจ พร้อมทั้งรับรองสำเนาถูกต้อง คนละ 1 ฉบับ"}
                                                                required={true}
                                                                color={"rgba(0, 0, 0, 0.6)"}
                                                            />
                                                            {/* <Typography variant='body1' color={"rgba(0, 0, 0, 0.6)"}>{"สำเนาบัตรประจำตัวประชาชน หรือบัตรประจำตัวเจ้าหน้าที่รัฐ หรือใบอนุญาตขับรถ หรือ หนังสือเดินทาง หรือบัตรอื่นซึ่งทางราชการเป็นผู้ออกให้ ซึ่งมีรูปถ่าย ลายมือชื่อ และเลขบัตรประจำตัวประชาชน 13 หลักชัดเจน ของผู้มอบอำนาจ และผู้รับมอบอำนาจ พร้อมทั้งรับรองสำเนาถูกต้อง คนละ 1 ฉบับ"}<span color={'red'}>*</span></Typography> */}
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <UploadFileItem
                                                                required={true}
                                                                modeDisplay={"list"}
                                                                id={"arrFile_7"}
                                                                name={"arrFile_7"}
                                                                label={""}
                                                                arrFile={arrFile_7}
                                                                setarrFile={setarrFile_7}
                                                                Extension={["pdf","jpeg", "png"]}
                                                                IsFolder={true}
                                                                onClearFile={onClearFile_7}
                                                                sFolderTemp="Project"
                                                                IsMultiple={true}
                                                                nLimitFile={10}
                                                                sLimitFile="MB"
                                                                sPositionText="right"
                                                                IsCrop={true}
                                                                cropShape={"retangle"}
                                                                cropRatio={16 / 9}
                                                                cropResize={true}
                                                                cropMovable={true}
                                                                isRequiredLimitFile={true}
                                                                disabled={!isPermission || isEditSecretary === false}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                        <Grid item xs={12} md={12} container spacing={1}>
                                                            <Grid item>
                                                                <Typography variant='body1' color={"rgba(0, 0, 0, 0.6)"}>สำเนาเอกสารที่แสดงถึงการจัดตั้งให้มีสถานะเป็นนิติบุคคลของเจ้าของโครงการ หรือผู้มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน</Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography variant='body1' color={'red'}>*</Typography>
                                                            </Grid>                        
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <UploadFileItem
                                                                required={true}
                                                                modeDisplay={"list"}
                                                                id={"arrFile_8"}
                                                                name={"arrFile_8"}
                                                                label={""}
                                                                arrFile={arrFile_8}
                                                                setarrFile={setarrFile_8}
                                                                Extension={["pdf","jpeg", "png"]}
                                                                IsFolder={true}
                                                                onClearFile={onClearFile_8}
                                                                sFolderTemp="Project"
                                                                IsMultiple={true}
                                                                nLimitFile={10}
                                                                sLimitFile="MB"
                                                                sPositionText="right"
                                                                IsCrop={true}
                                                                cropShape={"retangle"}
                                                                cropRatio={16 / 9}
                                                                cropResize={true}
                                                                cropMovable={true}
                                                                isRequiredLimitFile={true}
                                                                disabled={!isPermission || isEditSecretary === false}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                        <Grid item xs={12} md={12}>
                                                            <RadioListItem
                                                                id={"isPowerOfAttorney"}
                                                                name={"isPowerOfAttorney"}
                                                                label={"หนังสือมอบอำนาจปฏิบัติราชการแทน"}
                                                                IsNotShowLabel={false}
                                                                required={false}
                                                                options={OptionsProjectStatus_2}    
                                                                disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                                // row={false}
                                                                onChange={(e)=> {
                                                                    setisFile_9_isPowerOfAttorney(e === "Y");
                                                                }}
                                                            />                                                  
                                                        </Grid>
                                                        {isFile_9_isPowerOfAttorney &&
                                                            <Grid item xs={12} md={12}>
                                                                <UploadFileItem
                                                                    required={isFile_9_isPowerOfAttorney}
                                                                    modeDisplay={"list"}
                                                                    id={"arrFile_9"}
                                                                    name={"arrFile_9"}
                                                                    label={!isFile_9_isPowerOfAttorney ? "" : "ถ้า มี บังคับแนบไฟล์เอกสาร"}
                                                                    arrFile={arrFile_9}
                                                                    setarrFile={setarrFile_9}
                                                                    Extension={["pdf","jpeg", "png"]}
                                                                    IsFolder={true}
                                                                    onClearFile={onClearFile_9}
                                                                    sFolderTemp="Project"
                                                                    IsMultiple={true}
                                                                    nLimitFile={10}
                                                                    sLimitFile="MB"
                                                                    sPositionText="right"
                                                                    IsCrop={true}
                                                                    cropShape={"retangle"}
                                                                    cropRatio={16 / 9}
                                                                    cropResize={true}
                                                                    cropMovable={true}
                                                                    isRequiredLimitFile={true}
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                />
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                                    <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }}/>
                                                </Grid>
                                            </>  
                                        }
                                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body1' color={'blue'}>กรณีที่โครงการมีผู้เข้าร่วมโครงการจากหน่วยงานอื่นที่ไม่ใช่หน่วยงานเดียวกับเจ้าของโครงการ ให้มีเอกสารจากหน่วยงานต้นสังกัดที่ยินยอมให้ผู้เข้าร่วมโครงการดำเนินโครงการ</Typography>                                                        
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <RadioListItem
                                                    id={"isIntegrationUnit"}
                                                    name={"isIntegrationUnit"}
                                                    label={"บูรณาการความร่วมมือแบบหลายหน่วยงานหรือไม่"}
                                                    IsNotShowLabel={true}
                                                    required={true}
                                                    options={OptionsProjectStatus_1}    
                                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                                    // row={false}
                                                    onChange={(e)=> {
                                                        setisFile_10_isIntegrationUnit(e === "Y");
                                                    }}
                                                />
                                            </Grid>
                                            <Grid id='myDivSecondaryUnit' item xs={12} md={12} container spacing={3} style={{ display: isFile_10_isIntegrationUnit ? "" : "none" }}>
                                                <FormProvider {...formSecondaryUnit}>
                                                    <Grid item xs={12} md={12} container spacing={2}>
                                                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                                                            <Grid item xs={12} md={12}>
                                                                <TextBoxItem
                                                                    id={"sUnitName"}
                                                                    name={"sUnitName"}
                                                                    type={"text"}
                                                                    label={"ระบุชื่อหน่วยงานรอง (พร้อมทั้งแนบไฟล์เอกสารยินยอม)"}
                                                                    placeholder={"ระบุชื่อหน่วยงานรองให้ครบถ้วน"}
                                                                    required={isFile_10_isIntegrationUnit}
                                                                    maxLength={250}
                                                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={12}>
                                                                <UploadFileItem
                                                                    required={isFile_10_isIntegrationUnit}
                                                                    modeDisplay={"list"}
                                                                    id={"arrFile_10"}
                                                                    name={"arrFile_10"}
                                                                    label={!isFile_10_isIntegrationUnit ? "" : "ถ้า ใช่ บังคับแนบไฟล์เอกสาร"}
                                                                    arrFile={arrFileSecondaryUnit}
                                                                    setarrFile={setarrFileSecondaryUnit}
                                                                    Extension={["pdf","jpeg", "png"]}
                                                                    IsFolder={true}
                                                                    onClearFile={onClearFileSecondaryUnit}
                                                                    sFolderTemp="Project"
                                                                    IsMultiple={true}
                                                                    nLimitFile={10}
                                                                    sLimitFile="MB"
                                                                    sPositionText="right"
                                                                    IsCrop={true}
                                                                    cropShape={"retangle"}
                                                                    cropRatio={16 / 9}
                                                                    cropResize={true}
                                                                    cropMovable={true}
                                                                    isRequiredLimitFile={true}
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                                            {(nSecondaryUnitIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                                (nStatusID !== EnumProjectStatusID.nStatusID_11 &&
                                                                    <BtnAdd id={"btnAdd_Table_SecondaryUnit"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่ม"} onClick={formSecondaryUnit.handleSubmit((e) => onAddSecondaryUnit(),(err) => console.log("err", err))} />
                                                                )
                                                                :
                                                                <>
                                                                    {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                                        <Grid item>
                                                                            <BtnSave id={"btnSave_Table_SecondaryUnit"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formSecondaryUnit.handleSubmit((e) => onAddSecondaryUnit(),(err) => console.log("err", err))} />
                                                                        </Grid>
                                                                    }
                                                                    {nSecondaryUnitIDEdit !== 0 &&
                                                                        <Grid item>
                                                                            <BtnCancel id={"btnCancel_Table_SecondaryUnit"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnSecondaryUnitIDEdit(0); setObjSecondaryUnitIDEdit(null); onClearFieldSecondaryUnit(); }} />
                                                                        </Grid>   
                                                                    }               
                                                                </>
                                                            }
                                                        </Grid>
                                                    </Grid>                                          
                                                    <Grid item xs={12} md={12}>
                                                        <DataGrid
                                                            sTableID='TB_Project_Panel0_SecondaryUnit'
                                                            columns={dataColumnSecondaryUnit}
                                                            rows={DataRowSecondaryUnit}
                                                            isShowColomnTool={false}
                                                            isHiddenToolHead={true}
                                                            isShowCheckBox={false}
                                                            isHiddenPagination={true}
                                                        />
                                                    </Grid>
                                                </FormProvider>  
                                            </Grid>
                                        </Grid>                                     
                                    </FormProvider>  
                                </Grid>
                            </AccordionPanel>
                        </Grid> 
                        {nProgressStatusID === EnumProjectStatusID.nStatusID_28 ?
                            <></>
                        :
                            (isPermission === true && 
                                (isModeSecretary !== true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                            <Grid item>
                                                {/* <BtnDraft id={"btnDraft"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} /> */}
                                                <BtnDraft id={"btnDraft_Panel0"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Draft),(err) => console.log("err", err))} />
                                            </Grid> 
                                        }                                
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel0"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))} />
                                            {/* <BtnSendRequest 
                                                id={"btnSend"} 
                                                txt={I18n.SetText("Button.SendProjectPanel", I18NextNs.labelComponent)} 
                                                onClick={()=> {
                                                    form.handleSubmit((e) => {
                                                        formDocument.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err));
                                                    },(err) => console.log("err", err))
                                                }} 
                                            /> */}
                                        </Grid> 
                                    </Grid>
                                : 
                                    (isModeSecretary === true ?
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {isEditSecretary === false ?
                                                <Grid item>
                                                    <BtnEdit id={"btnEdit_Panel0"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel0").scrollIntoView({ behavior: "smooth" }); }} />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Panel0"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnSendRequest id={"btnSend_Panel0"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))} />
                                                    </Grid>
                                                </>
                                            }   
                                        </Grid>
                                        : <></>
                                    )
                                )
                            )
                        }
                    </FormProvider>  
                </Grid>        
            </Grid>  
        </AccordionPanel>
    )
}
export default Panel0;